import { HttpClient } from '@angular/common/http';
import { inject, Injectable, Signal } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import { BaseMaintenanceService, MaintenanceInfo, StorageService } from '@kerberos-compliance/compliance-shared-ui';
import { lastValueFrom } from 'rxjs';
import { StorageServiceKeysMap } from '@/storage/types/storage.types';

@Injectable({ providedIn: 'root' })
export class MaintenanceService extends BaseMaintenanceService {
  private httpClient = inject(HttpClient);

  private environmentService = inject(EnvironmentService);

  private storageService = inject(StorageService);

  /**
   * Fetches the maintenance status from an external service.
   *
   * @returns {Promise<MaintenanceInfo | undefined>} A promise that resolves to the MaintenanceInfo object if available,
   * or undefined if no maintenance information is found.
   */
  public getMaintenanceStatus(): Promise<MaintenanceInfo | undefined> {
    return lastValueFrom(this.httpClient.get<MaintenanceInfo>(this.environmentService.maintenanceInfoUrl));
  }

  /**
   * Clears the maintenance notice preference from storage.
   *
   * @returns {void} This method does not return any value.
   */
  public clearMaintenanceNotice(): void {
    this.storageService.remove(StorageServiceKeysMap.ShowMaintenanceNotice);
  }

  /**
   * Retrieves the user's preference for showing the maintenance notice.
   *
   * @returns {Signal<boolean>} Returns a signal indicating whether the maintenance notice should be shown.
   */
  public getShowMaintenanceNoticePreference(): Signal<boolean> {
    return this.storageService.getSignal<boolean>(StorageServiceKeysMap.ShowMaintenanceNotice, true);
  }
}
